<div aria-live="polite" aria-relevant="additions" class="map-notices">
  @for (notice of notices(); track notice.id) {
    <div class="map-notice" [class.is-ready]="notice.kind === 'ready'">
      <at-icon class="map-notice-icon">{{ notice.icon }}</at-icon>

      <div class="map-notice-body">
        <p class="map-notice-title">{{ notice.title }}</p>
        <p class="map-notice-post" [id]="'map-notice-post-' + notice.id">
          {{ notice.job.caption || 'Instagram post' }}
        </p>
      </div>

      @if (notice.kind === 'ready') {
        <a
          class="map-notice-action"
          [attr.aria-describedby]="'map-notice-post-' + notice.id"
          [routerLink]="['/map', notice.job.requestId]"
          (click)="dismiss(notice.id)"
        >
          {{ notice.action }}
        </a>
      } @else if (notice.kind === 'unavailable') {
        <a
          aria-label="View post on Instagram (opens in a new tab)"
          class="map-notice-action"
          rel="noopener noreferrer"
          target="_blank"
          [attr.aria-describedby]="'map-notice-post-' + notice.id"
          [href]="notice.job.videoUrl"
          (click)="dismiss(notice.id)"
        >
          {{ notice.action }}
          <at-icon aria-hidden="true">open_in_new</at-icon>
        </a>
      } @else if (notice.kind !== 'limit') {
        <button
          class="map-notice-action"
          type="button"
          [attr.aria-describedby]="'map-notice-post-' + notice.id"
          (click)="onRetry(notice)"
        >
          {{ notice.action }}
        </button>
      }

      <button
        aria-label="Dismiss"
        class="map-notice-close"
        type="button"
        [attr.aria-describedby]="'map-notice-post-' + notice.id"
        (click)="dismiss(notice.id)"
      >
        <at-icon>close</at-icon>
      </button>
    </div>
  }
</div>
